<template>
  <div class="retailers">
    <div class="buttons-section flex">
        <div class="text-center --green pointer flex" v-ripple @click="retailersDialog = true">
            <div class="icon add flex">
                <img src="@/assets/MainDashboard/Products/Add.svg" alt="">
            </div>
            Add New Retailers
        </div>

        <div class="text-center pointer flex" style="color: #2D60C2;" v-ripple>
            <div class="icon set flex">
                <img src="@/assets/MainDashboard/Retailers/SetGoal.svg" alt="">
            </div>
            Set a Goal For Retailers
        </div>
    </div>

    <div class="filters flex">
      <div class="retailer-wise flex">
        <p class="my-0 mr-4 --weight active pointer">1,253 Active Retailers</p>
        <p class="my-0 --weight pointer">343 Favourite Retailers</p>
      </div>

      <div>
        <button class="--green --weight"> 
          + Add filters 
        </button>
      </div>
    </div>

    <div class="retailers-card-section">
        <retailer-card v-for="(card, index) in data" :key="index" :item="card" />
    </div>

    <add-retailers :dialog="retailersDialog" :heading="'Add Retailers'" @closeModal="retailersDialog = false" />
  </div>
</template>

<script>
import data from '../../../../temp/retailers';
import retailerCard from './components/retailer-card.vue';
import addRetailers from '../Common/add-retailers__products.vue';
export default {
  name : 'retailers',

  data() {
    return {
      data : data,
      retailersDialog : false
    }
  },

  components : {
    'retailer-card' : retailerCard,
    'add-retailers' : addRetailers,
  }
}
</script>

<style lang="scss" scoped>
@import url('../Common/styles.css');
.flex{
  display: flex;
}
.buttons-section {
    justify-content: space-between;
}

.buttons-section > div {
    background-color: white;
    box-shadow: 1px 1px 1px rgba(17, 58, 34, 0.07);
    border-radius: 3px;
    width: 49%;
    height: 90px;
    position: relative;
    font-weight: 500;
    font-size: 18px;
    transition: 0.4s;
}

.buttons-section > div:nth-child(1):hover {
    background: #F4FAF7;
}

.buttons-section > div:nth-child(2):hover {
  background: #F4F5FB;
}

.icon {
    border-radius: 7px;
    width: 70px;
    height: 70px;
    position: absolute;
    left: 10px;
}

.icon.add {
    background: #F4FAF7;
}

.icon.set {
    background: #F4F5FB;
}

.filters {
  justify-content: space-between;
  margin-top: 25px;
}

.retailer-wise p {
  color: #8A8F8C;
  &.active {
    color: var(--primary-font);
  }
}

button {
  background: #EBF5F0;
  border-radius: 3px;
  font-size: 0.8rem;
  padding: 8px 18px;
}

</style>